import React, { useEffect } from "react";

import Heading from "../../elements/heading";
// import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";
import BodyText from "../../elements/body-text";
import "../card-info/style.scss";
// import api from "../../utils/api";
// import config from "../../temp/config";
import { connect } from "react-redux";
import PaymentQRCode from "../payment-qr-code";
// let agreeToTermsVal = true;
let summary = null;
const PreSalesCardInfoInStore = ({
  // user,
  qrCodeSrc,
  onSubmit,
  // onArvatoFrameClick,
  // arvatoOptions,
  heading,
  headingType,
  // termsAndConditions,
  ctaNameSubmit,
  colorSchemeSubmit,
  iconNameSubmit,
  // termsConditionsLabel,
  // termsConditionsBody,
  // savePaymentLabel,
  // savePaymentBody,
  disclaimer,
  // termsCheckbox,
  // paymentInfoCheckbox,
  // lang,
  becomeAMemberSummary,
  submitting,
  inStore
}) => {
  // const [agreeToTerms, setAgreeToTerms] = useState(false);
  // const [agreedToTermsHasError, setAgreedToTermsHasError] = useState(false);
  useEffect(() => {
    summary = becomeAMemberSummary;
  }, [becomeAMemberSummary]);
  // const termsProps = {
  //   label: termsConditionsLabel.value,
  //   infoText: termsConditionsBody.value,
  //   error: agreedToTermsHasError,
  //   checked: agreeToTerms,
  //   onChange: checked => {
  //     setAgreeToTerms(checked);
  //     agreeToTermsVal = checked;
  //     setAgreedToTermsHasError(false);
  //   }
  // };
  const submitButtonProps = {
    buttonText: ctaNameSubmit.value,
    iconName: iconNameSubmit,
    colorScheme: colorSchemeSubmit,
    disabled: submitting,
    callback: async evt => {
      onSubmit && onSubmit();
    }
  };
  return (
    <section className="card-info">
      {qrCodeSrc && (
        <>
          <div className="title">
            <Heading type={headingType} html={heading} />
          </div>
          <PaymentQRCode qrCodeSrc={qrCodeSrc} />
        </>
      )}
      {!qrCodeSrc && (
        <div className="submit">
          <PrimaryButton {...submitButtonProps} />
        </div>
      )}
      <BodyText html={disclaimer.value} className="body-text" />
    </section>
  );
};
const mapStateToProps = state => ({
  becomeAMemberSummary: state.becomeAMemberSummary
});
export default connect(mapStateToProps)(PreSalesCardInfoInStore);
